import { render, staticRenderFns } from "./SopOverviewImage.vue?vue&type=template&id=007a693d&scoped=true&"
import script from "./SopOverviewImage.vue?vue&type=script&lang=ts&"
export * from "./SopOverviewImage.vue?vue&type=script&lang=ts&"
import style0 from "./SopOverviewImage.vue?vue&type=style&index=0&id=007a693d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007a693d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
